import { IRegisterStep } from '../../registerSteps';
import StartRegisterPage from '.';

const StartRegisterStep: IRegisterStep = {
  name: 'Informações da empresa',
  step: (props: any) => <StartRegisterPage {...props} />,
};

export default StartRegisterStep;
